import { render, staticRenderFns } from "./MenuBarEn.vue?vue&type=template&id=9071d7da&"
import script from "./MenuBarEn.vue?vue&type=script&lang=js&"
export * from "./MenuBarEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports